import { setWaterMark, removeWatermark } from "./watermark";
import { getClientIpInfo } from "./clientInfo";

/**
 * 将日期格式化为 YYYY-MM-DD HH:mm:ss。
 * @param {Date} date 日期对象
 * @returns {string}
 */
function formatDateTime(date) {
  const pad = (n) => (n < 10 ? "0" + n : String(n));
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    " " +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds())
  );
}

/**
 * 读取路由中的预览 key。
 * @param {unknown} key 路由 query.key
 * @returns {string|undefined}
 */
function resolvePreviewKey(key) {
  return typeof key === "string" && key.trim() ? key.trim() : undefined;
}

/**
 * 预览态全页水印 mixin：URL 含 key 时展示「仅供预览 / 时间 / IP」。
 * 对齐 PC 端 usePreviewWatermark。
 */
export default {
  data() {
    return {
      _previewWatermarkTime: "",
    };
  },
  watch: {
    "$route.query.key": {
      immediate: true,
      handler(key) {
        this.syncPreviewWatermark(key);
      },
    },
  },
  beforeDestroy() {
    removeWatermark();
  },
  methods: {
    /**
     * 进入/退出预览态时同步水印。
     * @param {unknown} key 路由 query.key
     */
    async syncPreviewWatermark(key) {
      const previewKey = resolvePreviewKey(key);
      if (!previewKey) {
        removeWatermark();
        return;
      }

      if (!this._previewWatermarkTime) {
        this._previewWatermarkTime = formatDateTime(new Date());
      }
      const previewTime = this._previewWatermarkTime;

      setWaterMark("仅供预览，非正式稿件", previewTime, "IP: ");
      const ip = await getClientIpInfo();

      if (!resolvePreviewKey(this.$route.query.key)) {
        removeWatermark();
        return;
      }

      setWaterMark(
        "仅供预览，非正式稿件",
        previewTime,
        "IP: " + (ip || "未知"),
      );
    },
  },
};
